/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import DOMPurify from "dompurify";
import { useDispatch, useSelector } from "react-redux";
import { getSettingApi } from "../../../Features/Setting/Setting";
import PolicyLayout from "./PolicyLayout";

function Privacy() {
  const dispatch = useDispatch();
  const setting = useSelector((s) => s.setting?.settingData);

  useEffect(() => {
    dispatch(getSettingApi());
    window.scrollTo(0, 0);
  }, []);

  return (
    <PolicyLayout
      breadcrumb="Privacy Policy"
      eyebrow="Legal"
      title="Privacy Policy"
      intro="How we collect, store and use your personal information when you visit thediamondcounter.com or buy from us."
      htmlBlocks={[
        DOMPurify.sanitize(setting?.app_privacy_policy || ""),
        DOMPurify.sanitize(setting?.app_cod_policy || ""),
      ]}
      fallback="Our privacy policy is being updated. Contact us if you'd like more detail on how we handle your data in the meantime."
      contactCtaText="Questions about how we handle your data? We're happy to walk you through it."
    />
  );
}

export default Privacy;
